// extracted by mini-css-extract-plugin
export default {"faq__item":"faq-Item_faq__item__x8yHX"};